import { render, staticRenderFns } from "./CongressView.vue?vue&type=template&id=637baa24"
import script from "./CongressView.vue?vue&type=script&lang=js"
export * from "./CongressView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports